
// based on PanomNom.js, https://github.com/spite/PanomNom.js/
// which has license: MIT

/*eslint no-redeclare:0, no-useless-escape:0, eqeqeq:0 */

import { EventDispatcher } from 'three';
import { GMAPS_CB_CLIENT } from '../config';

  var PANOMNOM = {}

  PANOMNOM.GOOGLEMAPSAPI = '//maps.google.com/maps/api/js?sensor=false';
  PANOMNOM.GoogleStreetViewService = null;
  PANOMNOM.GoogleGeoCoder = null;

  PANOMNOM.Utils = {

    loadAsync: function(src, c) {

      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = src;
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
      s.addEventListener('load', c);

    },

    getGoogleStreetViewService: function() {

      if (PANOMNOM.GoogleStreetViewService) return PANOMNOM.GoogleStreetViewService;

      PANOMNOM.GoogleStreetViewService = new window.google.maps.StreetViewService({
        radius: 1000,
        preference: window.google.maps.StreetViewPreference.NEAREST,
        source: window.google.maps.StreetViewSource.OUTDOOR,
      });
      return PANOMNOM.GoogleStreetViewService;

    },

    getGoogleGeoCoder: function() {

      if (PANOMNOM.GoogleGeoCoder) return PANOMNOM.GoogleGeoCoder;

      PANOMNOM.GoogleGeoCoder = new window.google.maps.Geocoder();
      return PANOMNOM.GoogleGeoCoder;

    },

    resolveAddress: function(address, callback) {

      var geocoder = this.getGoogleGeoCoder();
      geocoder.geocode({ 'address': address }, function(results, status) {
        if (status == window.google.maps.GeocoderStatus.OK) {
          callback(results[0].geometry.location);
        } else {
          //showError("Geocode was not successful for the following reason: " + status);
          //showProgress( false );
        }
      });

    }

  };

  PANOMNOM.Stitcher = function(canvas) {

    this.canvas = canvas;
    this.ctx = this.canvas.getContext('2d');
    this.queue = [];
    this.toLoad = 0;
    this.loaded = 0;

  }

  var eventListeners = [];

  function createEventListener(obj, event, func) {
     obj.addEventListener(event, func);
     eventListeners.push({'obj':obj, 'event':event, 'func':func});
  }

  function removeEventListeners() {
     for(var i=0;i<eventListeners.length;i++) {
        var item = eventListeners[i];
        item.obj.removeEventListener(item.event, item.func);
     }
  }

  PANOMNOM.Stitcher.prototype.clear = function() {

    this.queue = [];
    this.toLoad = 0;
    this.loaded = 0;

    removeEventListeners();

  }

  PANOMNOM.Stitcher.prototype.reset = function() {

    this.toLoad = 0;
    this.loaded = 0;

  }

  PANOMNOM.Stitcher.prototype.addTileTask = function(task) {

    this.queue.push(task);
    this.toLoad++;

  }

  let lastNow = 0;

  PANOMNOM.Stitcher.prototype.updateProgress = function() {
    let now = Date.now();
    if(now-lastNow>300) {
        var p = this.loaded * 100 / this.toLoad;
        this.dispatchEvent({ type: 'progress', message: p });
        lastNow = now;
    }

  }

  PANOMNOM.Stitcher.prototype.processQueue = function() {

    this.updateProgress();

    if (this.queue.length === 0) {
      this.dispatchEvent({ type: 'finished' });
      return;
    }

    var task = this.queue.shift();

    var img = new Image();
    createEventListener(img, 'load', function() {

      this.loaded++;

      this.ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, task.x, task.y, 512, 512);
      this.processQueue();

      img = null;

    }.bind(this));

    createEventListener(img, 'error', function() {
      this.dispatchEvent({ type: 'error', message: 'images missing' });
      this.processQueue();

      img = null;

    }.bind(this));

    img.crossOrigin = '';
    img.src = task.url;

  }

  Object.assign( PANOMNOM.Stitcher.prototype, EventDispatcher.prototype );

  PANOMNOM.Loader = function() {

    this.canvas = document.createElement('canvas');
    this.ctx = this.canvas.getContext('2d');

    this.stitcher = new PANOMNOM.Stitcher(this.canvas);
    this.stitcher.addEventListener('finished', function() {
      this.dispatchEvent({ type: 'load', message: 'Panorama loaded' });
    }.bind(this));

    this.stitcher.addEventListener('progress', function(e) {
      this.dispatchEvent({ type: 'progress', message: e.message });
    }.bind(this));

    this.stitcher.addEventListener('error', function(e) {
      this.dispatchEvent({ type: 'error', message: e.message });
    }.bind(this));

  }

  PANOMNOM.Loader.prototype.load = function() {

  }

  PANOMNOM.Loader.prototype.error = function(msg) {

    this.dispatchEvent({ type: 'error', message: msg });

  }

  Object.assign( PANOMNOM.Loader.prototype, EventDispatcher.prototype );

  PANOMNOM.GoogleStreetViewLoader = function() {

    PANOMNOM.Loader.call(this);

    this.service = PANOMNOM.Utils.getGoogleStreetViewService();

    this.levelsW = [1, 2, 4, 8, 16, 32];
    this.levelsH = [1, 1, 2, 4, 8, 16];

    this.widths = [512, 1024, 2048, 4096, 8192, 16384];
    this.heights = [416, 512, 1024, 2048, 4096, 8192];

    this.zoom = 3;

    this.metadata = {};

  }

  PANOMNOM.GoogleStreetViewLoader.prototype = Object.create(PANOMNOM.Loader.prototype);

  PANOMNOM.GoogleStreetViewLoader.prototype.load = function(id, zoom, latDegrees) {
    if (zoom === undefined) {
      console.warn('No zoom provided, assuming 1');
      zoom = 1;
    }

    this.zoom = zoom;
    this.panoId = id;

    this.canvas.width = this.widths[zoom];
    this.canvas.height = this.heights[zoom];

    var w = this.levelsW[zoom];
    var h = this.levelsH[zoom];

    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {

        var url = 'https://streetviewpixels-pa.googleapis.com/v1/tile?cb_client=' + GMAPS_CB_CLIENT + '&hl=en&panoid=' + id + '&x=' + x + '&y=' + y + '&zoom=' + zoom + '&nbt=1&fover=2';

        this.stitcher.addTileTask({

          url: url,
          x: x * 512,
          y: y * 512,

        });
      }
    }

    url = "//maps.google.com/cbk?output=json&hl=x-local&cb_client=" + GMAPS_CB_CLIENT + "&v=4&dm=1&pm=1&ph=1&hl=en&panoid=" + id

    this.service.getPanoramaById(id, function(result, status) {
      if (result === null) {
        this.error('Can\'t load panorama information');
        return;
      }

      this.metadata = result;
      this.dispatchEvent({ type: 'data', message: result });
      this.stitcher.processQueue();
    }.bind(this));
  }

  PANOMNOM.GoogleStreetViewLoader.prototype.loadFromLocation = function(location, zoom, idCallback) {

    this.getIdByLocation(
      location,
      function(id) {
        this.load(id, zoom);
        idCallback(id);
      }.bind(this)
    );

  }

  function getQueryVariable(query, variable) {

    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }

  }


  PANOMNOM.GoogleStreetViewLoader.prototype.loadFromURL = function(url, zoom) {

    if (url.indexOf('panoid') != -1) {
      var panoId = getQueryVariable(url, 'panoid');
      this.load(panoId, 2);
    } else if (url.indexOf('!1s') != -1) {
      var pos = url.indexOf('!1s') + 3;
      var npos = url.substr(pos).indexOf('!');
      var panoId = url.substr(pos, npos);
      this.load(panoId, zoom);
    } else {
      this.dispatchEvent({ type: 'error', message: 'can\'t find panorama id in specified URL' });
    }

  }

  PANOMNOM.GoogleStreetViewLoader.prototype.getIdByLocation = function(location, callback) {

    var url = 'https://cbks0.google.com/cbk?cb_client=' + GMAPS_CB_CLIENT + '&hl=en&output=polygon&it=1%3A1&rank=closest&ll=' + location.lat() + ',' + location.lng() + '&radius=1000';

    var http_request = new XMLHttpRequest();
    http_request.open('GET', url, true);
    http_request.onreadystatechange = function() {
      if (http_request.readyState == 4 && http_request.status == 200) {
        var data = JSON.parse(http_request.responseText);
        if (!data || !data.result || data.result.length === 0) {
          this.error('No panoramas around location');
        } else {
          callback(data.result[0].id);
        }
      }
    }.bind(this);
    http_request.send(null);

  }

  PANOMNOM.GooglePhotoSphereLoader = function() {

    PANOMNOM.Loader.call(this);

    this.service = PANOMNOM.Utils.getGoogleStreetViewService();

    this.levelsW = [1, 2, 4, 8, 16, 32];
    this.levelsH = [1, 1, 2, 4, 8, 16];

    this.widths = [512, 1024, 2048, 4096, 8192, 16384];
    this.heights = [416, 512, 1024, 2048, 4096, 8192];

    this.zoom = 1;

    this.metadata = {};

  }

  PANOMNOM.GooglePhotoSphereLoader.prototype = Object.create(PANOMNOM.Loader.prototype);


  PANOMNOM.GooglePhotoSphereLoader.prototype.getIdByLocation = function(location, callback) {
    var url = 'https://cbks0.googleapis.com/cbk?cb_client=' + GMAPS_CB_CLIENT + '&hl=en&output=polygon&it=1%3A1&rank=closest&ll=' + location.lat() + ',' + location.lng() + '&radius=1000';

    var http_request = new XMLHttpRequest();
    http_request.open('GET', url, true);
    http_request.onreadystatechange = function() {
      if (http_request.readyState == 4 && http_request.status == 200) {
        var data = JSON.parse(http_request.responseText);
        if (!data || !data.result || data.result.length === 0) {
          this.error('No panoramas around location');
        } else {
          // the data would also have score, yaw, image type and camera rotation (but no depth)
          callback(data.result[0].id);
        }
      }
    }.bind(this);
    http_request.send(null);

  }


  PANOMNOM.GooglePhotoSphereLoader.prototype.loadFromLocation = function(location, zoom, newLon, fov, idCallback) {

    this.getIdByLocation(
      location,
      function(id) {
        this.load(id, zoom, newLon, fov);
        idCallback(id);
      }.bind(this)
    );

  }

  PANOMNOM.GooglePhotoSphereLoader.prototype.loadFromURL = function(url, zoom) {

    if (url.indexOf('!1s') != -1) {
      var pos = url.indexOf('!1s') + 3;
      var npos = url.substr(pos).indexOf('!');
      var panoId = url.substr(pos, npos);
      this.load(panoId, zoom);
      // https://www.google.com/maps/preview?authuser=0#!q=Eleanor+Roosevelt+Playground&data=!1m8!1m3!1d3!2d-73.935845!3d40.693159!2m2!1f170.65!2f90!4f75!2m4!1e1!2m2!1s0Zn7rPD9Q4KOhRyEugT1qA!2e0!4m15!2m14!1m13!1s0x0%3A0x63459d24c457bec7!3m8!1m3!1d11440!2d-73.9085059!3d40.6833656!3m2!1i1329!2i726!4f13.1!4m2!3d40.6929389!4d-73.9357996&fid=5
    }

  };

  PANOMNOM.GooglePhotoSphereLoader.prototype.load = function(id, zoom, newLon, fov) {
    this.stitcher.clear();

    this.zoom = zoom;
    this.panoId = id;

    // maybe redefining this here kills the previous requests?
    // (or then just causes memory leaks)
    // didn't help :/
    //this.service = PANOMNOM.Utils.getGoogleStreetViewService();

    this.service.getPanoramaById(id, function(result, status) {

      if (result === null) {
        this.error('Can\'t load panorama information');
        return;
      }
        // inspired by: https://gist.github.com/toanalien/eb5fb7d2c7a167a3e3cf

        this.tiles = result.tiles;
        this.links = result.links;
        var data = result.tiles;

        //if (true) {
        // if meta info is specified, we will compute the exact tile sizes
        // works with StreetView and PhotoSphere

        var ratio = data.worldSize.width / data.tileSize.width;
        var nearestZoom = 4;
        if(ratio<16) nearestZoom = 2;
        // Setting nearestZoom to 4 seems to fix mapping to 3D sphere.

        let width = Math.floor(data.worldSize.width * Math.pow(2, zoom - 1) / Math.pow(2, nearestZoom));
        let height = Math.floor(data.worldSize.height * Math.pow(2, zoom - 1) / Math.pow(2, nearestZoom));
        let cols = Math.max(1, Math.ceil(width / data.tileSize.width));
        let rows = Math.max(1, Math.ceil(height / data.tileSize.height));
        let tileWidth = data.tileSize.width;
        let tileHeight = data.tileSize.height;

        /*

          } else {
        // otherwise, we approximate them assuming the result is
        // a regular StreetView panorama
            width = this.widths[zoom];
            height = this.heights[zoom];
            cols = this.levelsW[zoom];
            rows = this.levelsH[zoom];
            tileWidth = 512;
            tileHeight = 512;
          }*/

        this.canvas.width = width;
        this.canvas.height = height;

        for (var y = 0; y < rows; y++) {
            for (var x = 0; x < cols; x++) {
                var url = 'https://geo0.ggpht.com/cbk?cb_client=' + GMAPS_CB_CLIENT + '&hl=en&panoid=' + id + '&output=tile&x=' + x + '&y=' + y + '&zoom=' + zoom + '&nbt&fover=2';

                  this.stitcher.addTileTask({

                    url: url,
                    x: x * tileWidth,
                    y: y * tileHeight,

                  });
            }
        }

      this.stitcher.processQueue();

    }.bind(this));


  }

export default PANOMNOM;
